import DatabaseModel from './DatabaseModelOffline.js';

var Comunidad = Object.create(DatabaseModel);

Comunidad.model = 'comunidades';

Comunidad.getCombo = function(params, shownFields = []){
    var self = this;
    var comboParams = Object.assign({}, params);
    // Si vamos por mongo, hacer que en los params se hagan como un like insensitivo
    if (comboParams.filter) {
        for (var f in comboParams.filter) {
            if (f == undefined) {
                continue;
            }
            if (f == 'codProvincia') {
                if (process.env.TARGET == 'web') {
                    comboParams.filter["provincias"] = { "$contains": comboParams.filter[f]};
                } else {
                    comboParams.filter["provincias"] = { "$in": [comboParams.filter[f]]};
                }
                delete comboParams.filter[f];
                continue;
            }
            comboParams.filter[f] = { "$regex": comboParams.filter[f], "$options": "i" };
        }
    }
    if(shownFields.length){
        comboParams.projection = shownFields.join(",");
    }
    return self.getList(comboParams);
};

export default Comunidad;